import React from 'react';

import { ContainerButtCapa } from '../../styles';
import { Row, Col } from 'react-bootstrap';

import { MdOutlineCancel } from 'react-icons/md';
import { IoIosSearch } from 'react-icons/io';
import { FaEraser } from 'react-icons/fa';
import { useConferenciaTesouraria } from '../../ConferenciaTesourariaContext';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';

const ContainerButtonCapa: React.FC = () => {
  const {
    loaderSearch,
    disableButtonCancel,
    disableButtonClear,
    disableButtonSearch,
    handledisableTurno,
    handleSearch,
    resetInput,
    handleCancel,
  } = useConferenciaTesouraria();
  return (
    <ContainerButtCapa>
      <Row style={{ width: '100%' }}>
        <Col md={12} sm={12} className="colButton">
          <CustomButtonNovo
            disabled={disableButtonSearch || loaderSearch}
            onClick={() => {
              handleSearch();
              // handledisableTurno(false);
            }}
            showLoading={loaderSearch}
            label="Pesquisar"
            icon={IoIosSearch}
          />
        </Col>
        <Col md={12} sm={12} className="colButton">
          <CustomButtonNovo
            disabled={disableButtonCancel}
            onClick={() => handleCancel()}
            label="Cancelar"
            icon={MdOutlineCancel}
            variant="cancel"
          />
        </Col>
        <Col md={12} sm={12} className="colButton2">
          <CustomButtonNovo
            onClick={() => resetInput()}
            disabled={disableButtonClear}
            label="Limpar"
            icon={FaEraser}
            variant="clear"
          />
        </Col>
      </Row>
    </ContainerButtCapa>
  );
};

export default ContainerButtonCapa;
